import Vue from 'vue'
import Vuex from 'vuex'
import app from './module/app'
import user from './module/user'
import product from './module/product'
import company from './module/company'
import customer from './module/customer'
import crop from './module/crop'
import finance from './module/finance'
import order from './module/order'
import purchase from './module/purchase'
import personal from './module/personal'
import supplier from './module/supplier'
import bbs from './module/bbs'
import source from '@/store/module/source'
import navigation from './module/navigation'
import employee from './module/employee'
import consult from '@/store/module/consult'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    user,
    employee,
    product,
    company,
    customer,
    crop,
    finance,
    order,
    purchase,
    personal,
    supplier,
    bbs,
    source,
    navigation,
    consult,
  }
})
